export var DELAY_MS_SHOW = 800;
export var DELAY_MS_HIDE = 200;